export default {
    topics: [
        {
            title: ' AliasCleansing ',
            href: 'sm-enum-AliasCleansing.html',
            attributes: { 'data-id': 'sm-enum-AliasCleansing' },
            menu: { hasChildren: false },
            tocID: 'sm-enum-AliasCleansing-d66e489',
            topics: [],
        },
        {
            title: ' GetCleanedValue ',
            href: 'sm-enum-GetCleanedValue.html',
            attributes: { 'data-id': 'sm-enum-GetCleanedValue' },
            menu: { hasChildren: false },
            tocID: 'sm-enum-GetCleanedValue-d66e497',
            topics: [],
        },
        {
            title: ' SwitchValuesAndAliases ',
            href: 'sm-enum-SwitchValuesAndAliases.html',
            attributes: { 'data-id': 'sm-enum-SwitchValuesAndAliases' },
            menu: { hasChildren: false },
            tocID: 'sm-enum-SwitchValuesAndAliases-d66e505',
            topics: [],
        },
    ],
};

